import { render } from "./payment-modal.vue?vue&type=template&id=285deb86"
import script from "./payment-modal.vue?vue&type=script&lang=js"
export * from "./payment-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__